import { useState, useRef, useCallback } from 'react';
import { EventBus as eventBus } from "@components/EventBus";
import { showGlobalLoading, hideGlobalLoading } from '@services/axiosInstance';
import pdfService from '@services/pdf';

const useDocumentPreview = (profile) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const printerRef = useRef(null);

  const generatePdfUrl = useCallback(async (
    documentData, 
    selectedPageSize, 
    selectedPageType, 
    options = {}
  ) => {
    try {
      return await pdfService.generatePdfUrl(documentData, selectedPageSize, selectedPageType, {
        ...options,
        idempresa: profile.idEmpresa
      });
    } catch (error) {
      console.error('Erro ao gerar URL do PDF:', error);
      throw error;
    }
  }, [profile.idEmpresa]);

  const handleSingleDocumentPrint = useCallback(async (
    documentData,
    selectedPageSize,
    selectedPageType,
    options = {}
  ) => {
    try {
      setIsSubmitting(true);
      showGlobalLoading('A gerar documento...');

      const url = await generatePdfUrl(documentData, selectedPageSize, selectedPageType, options);
      setPreviewUrl(url);

      // Wait a bit for the URL to be set, then trigger print
      setTimeout(() => {
        if (printerRef.current) {
          printerRef.current.handlePrint().then(() => {
            setIsSubmitting(false);
            hideGlobalLoading();
          });
        }
      }, 100);

    } catch (error) {
      console.error('Erro ao gerar preview:', error);
      setIsSubmitting(false);
      hideGlobalLoading();
    }
  }, [generatePdfUrl]);

  const handleBulkDocumentPrint = useCallback(async (
    documents,
    selectedPageSize,
    selectedPageType,
    options = {}
  ) => {
    try {
      setIsSubmitting(true);
      showGlobalLoading('A gerar documentos em lote...');

      const response = await pdfService.generateBulkPdf(
        profile.idEmpresa, 
        documents, 
        selectedPageSize, 
        selectedPageType
      );
      
      setPreviewUrl(response.url);

      setTimeout(() => {
        if (printerRef.current) {
          printerRef.current.handlePrint().then(() => {
            setIsSubmitting(false);
            hideGlobalLoading();
          });
        }
      }, 100);

    } catch (error) {
      console.error('Erro ao gerar PDF em bulk:', error);
      setIsSubmitting(false);
      hideGlobalLoading();
    }
  }, [profile.idEmpresa]);

  const openPrintModal = useCallback((modalId = "document-print") => {
    console.log('Abrindo modal:', `Modal-${modalId}`);
    // Add a small delay to ensure the modal is mounted
    setTimeout(() => {
      eventBus.$emit(`Modal-${modalId}`, { header: null, body: null, isOpen: true });
    }, 10);
  }, []);

  const closePrintModal = useCallback((modalId = "document-print") => {
    eventBus.$emit(`Modal-${modalId}`, { isOpen: false });
  }, []);

  return {
    previewUrl,
    setPreviewUrl,
    isSubmitting,
    setIsSubmitting,
    printerRef,
    generatePdfUrl,
    handleSingleDocumentPrint,
    handleBulkDocumentPrint,
    openPrintModal,
    closePrintModal
  };
};

export default useDocumentPreview;
